
  import {
    Vue,
    Component
  } from 'vue-property-decorator';
  import {
    AppModule
  } from '../../../store/modules/app';
  import {
    PermissionModule
  } from '../../../store/modules/permission'

  @Component({
    name: 'sidebar'
  })
  export default class Sidebar extends Vue {
    private ContractType = null
    get routeList() {
      return PermissionModule.dynamicRoutes;
    }

    get isCollapse() {
      return !AppModule.sidebar.opened;
    }
    private mounted () {
      let ContractType:any = window.localStorage.getItem('ContractType')
      this.ContractType = ContractType
    }
    private onlyOneChild(child: any) {
      const showChild = child.filter((item: any) => {
        return !item.hidden;
      })
      if (showChild.length <= 1 && showChild[0].meta.type === 'single') {
        return true;
      }
      return false;
    }
  }
